import React, { useContext } from 'react';
import './styles.scss';
import { ResetOverlayProps } from './interfaces';
import { ScreenEnum } from '../../enums';
import { useTranslation } from 'react-i18next';
import AppStateContext from '../../AppStateProvider/context';

export default function ResetOverlay(props: ResetOverlayProps) {
	const { dispatch } = useContext(AppStateContext);
	const { t } = useTranslation();

	const clearCaches = async () => {
		if ('caches' in window) {
			try {
				const cacheNames = await caches.keys();
				await Promise.all(cacheNames.map(name => caches.delete(name)));
			} catch (e) {
				console.log('Cache clear failed', e);
			}
		}
	};

	const performFrontendReset = async () => {
		// Local Storage
		try {
			localStorage.clear();
		} catch (e) {
			console.log("localStorage clear failed", e);
		}

		// Cache API
		await clearCaches();

		// Reset React State
		dispatch({ type: 'SET_SETUP', value: null });
		dispatch({ type: 'SET_PINPAIRING_ACTIVATIONRESPONSE', value: null });
		dispatch({ type: 'SET_PINPAIRING_DEVICECODE', value: null });
		dispatch({ type: 'SET_MARKET',
			value: {
				qsUrl: null,
				prodUrl: null
			}, });
		dispatch({ type: 'SET_BRAND', value: null });
		dispatch({ type: 'SET_DEVICE', value: null });

		// Screen reset inside React
		props.setScreen(ScreenEnum.welcome);
	};

	const handleReset = async () => {
		// Overlay schließen
		props.setResetOverlay(false);

		// 1) Frontend Reset (Cache, LocalStorage, etc.)
		await performFrontendReset();

		// 2) Reset über URL-Parameter anstoßen
		const resetUrl = `${window.location.origin}${window.location.pathname}?reset-app=true`;

		console.log("Triggering Android Reset via URL:", resetUrl);

		window.location.href = resetUrl;
	};

	return (
		<div className='reset-overlay'>
			<div className='inner'>
				<h3>{t('ResetOverlayHeadline')}</h3>
				<p className='p2'>{t('ResetOverlayText')}</p>

				<div>
					<button
						className='black small'
						onClick={() => props.setResetOverlay(false)}
					>
						{t('ButtonCancel')}
					</button>

					<button
						className='red small'
						onClick={handleReset}
					>
						{t('ResetOverlayReset')}
					</button>
				</div>
			</div>
		</div>
	);
}
